module.exports = __webpack_public_path__ + "static/media/22a.722601b6.jpg";